import css from 'styled-jsx/css';

const styles = css.global`#perguntas {
  margin-top: 40px;
}

#perguntas .title-perguntas {
  color: var(--black-01, #444);
  font-size: 24px;
  font-family: 'SantanderHeadline';
  line-height: 34px;
  font-weight: 400;
}

#perguntas .group-perguntas {
  margin: 16px 0 40px auto;
  max-width: 100%;
}

#perguntas .custom-accordion .acc-header .acc-title {
  font-size: 18px;
}

#perguntas .custom-accordion .acc-body.default p {
  font-size: 18px;
  line-height: 1.56;
}

#perguntas .link-faq {
  color: #C00;
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  border: none;
  background: none;
  display: block;
}

@media (min-width: 992px) {
  #perguntas {
    margin-top: 38px;
  }
  #perguntas .title-perguntas {
    font-size: 32px;
  }
  #perguntas .group-perguntas {
    margin: 47px 0 54px 0;
  }

  #perguntas .custom-accordion .acc-body.default p {
    max-width: 100%;
}
}
`;

export default styles;